import Vue from 'vue';
import Http from 'axios';
import ItemLimiter from '@app/components/Utilities/ItemLimiter.vue';
import VideoComponent from '@app/components/Video.vue';
export default Vue.extend({
    components: {
        ItemLimiter: ItemLimiter,
        VideoComponent: VideoComponent
    },
    props: {
        block: Object
    },
    data: function () { return ({
        categories: [],
        allProjects: [],
        selectedCategory: null,
    }); },
    created: function () {
        var _this = this;
        Http.get("/api/reference/category").then(function (res) {
            _this.categories = res.data;
        });
        Http.get("/api/reference/project").then(function (res) {
            _this.allProjects = res.data;
        });
    },
    computed: {
        filteredProjects: function () {
            if (this.selectedCategory != null) {
                return this.selectedCategory.projects;
            }
            return this.allProjects;
        }
    },
    methods: {
        selectCategory: function (cat) {
            this.selectedCategory = cat;
        },
        isCatSelected: function (cat) {
            if (this.selectedCategory === cat) {
                return true;
            }
            return false;
        }
    }
});
